<template>
  <div class="bg-image">
    <div class="row g-0 justify-content-center bg-primary-dark-op">
      <div
        class="hero-static col-sm-8 col-md-6 col-xl-4 d-flex align-items-center p-2 px-sm-0"
      >
        <!-- Reminder Block -->
        <div
          class="block block-transparent block-rounded w-100 mb-0 overflow-hidden"
        >
          <div
            class="block-content block-content-full px-lg-5 px-xl-6 py-4 py-md-5 py-lg-6 bg-body-extra-light"
          >
            <!-- Header -->
            <div class="mb-2 text-center">
              <router-link class="link-fx fw-bold fs-1" :to="{ name: 'login' }">
                <span class="text-dark">Save</span
                ><span class="text-primary">Control</span>
              </router-link>
              <p class="text-uppercase fw-bold fs-sm text-muted">
                Cambiar Contraseña
              </p>
            </div>
            <!-- END Header -->
            <div class="js-validation-reminder">
              <div class="mb-4">
                <div class="input-group input-group-lg">
                  <input
                    type="password"
                    class="form-control"
                    id="newPassword"
                    placeholder="Nueva Contraseña"
                    v-model="data.user.newPassword"
                  />
                  <a
                    class="btn btn-outline-secondary"
                    id="togglePassword"
                    @click="showPassword('newPassword', 'toggleIcon1')"
                  >
                    <i class="fa fa-eye" id="toggleIcon1"></i>
                  </a>
                </div>

                <div class="input-group input-group-lg mt-2">
                  <input
                    type="password"
                    class="form-control"
                    id="confirmPassword"
                    placeholder="Confirmar Contraseña"
                    v-model="data.user.confirmPassword"
                  />
                  <a
                    class="btn btn-outline-secondary"
                    id="togglePassword"
                    @click="showPassword('confirmPassword', 'toggleIcon1')"
                  >
                    <i class="fa fa-eye" id="toggleIcon1"></i>
                  </a>
                </div>
              </div>
              <div class="text-center mb-4">
                <button
                  type="submit"
                  class="btn btn-hero btn-primary"
                  @click="check_form()"
                >
                  <i class="fa fa-fw fa-reply opacity-50 me-1"></i>Cambiar
                  Contraseña
                </button>
              </div>
            </div>
            <!-- END Reminder Form -->
          </div>
        </div>
        <!-- END Reminder Block -->
      </div>
    </div>
  </div>
</template>
<script setup>
import passwordChage from "@/composables/usePasswordChange";
const { data, check_form, showPassword } = passwordChage();
</script>
